import {
	equal,
	integer,
	min,
	required,
	string,
	length,
} from 'vue-mc/validation';
import Model from './Model';
import Collection from './Collection';

export class CustomData extends Model {
	static FIELD_TYPES = [
		{ value: 'checkbox', text: 'Checkbox' },
		{ value: 'textInput', text: 'Text' },
		{ value: 'textarea', text: 'Textarea' },
		{ value: 'dropdownList', text: 'Dropdown' },
		// { value: 'multiselect', text: 'Multiselect' },
	];

	defaults() {
		return {
			id: null,
			label: '',
			type: '',
			disabled: false,
		};
	}

	mutations() {
		return {
			id: id => Number(id) || null,
			label: String,
			type: String,
			disabled: Boolean,
		};
	}

	validation() {
		return {
			id: integer.and(min(1)).or(equal(null)),
			label: string.and(required).and(length(1, 100)),
			type: string.and(required),
		};
	}

	routes() {
		return {
			create: '/custom-datas',
			fetch: '/custom-datas/{id}',
			patch: '/custom-datas/{id}',
			delete: '/custom-datas/{id}',
			completion: '/custom-datas/{id}/completion',
		};
	}

	options() {
		return {
			patch: true,
		};
	}
	
	toggleDisabled() {
		this.disabled = !this.disabled;

		const method = this.getOption('methods.patch');
		const route = this.getRoute('patch');
		const url = this.getURL(route, this.getRouteParameters());
		
		return new Promise((resolve, reject) => {
			this.loading = true;
			this.getRequest({
				method,
				url,
				headers: { Authorization: '' },
				data: { disabled: this.disabled },
			})
			.send()
			.then(({ response }) => {
				this.disabled = response.data.disabled;
				resolve(response);
			}).catch((error) => {
				reject(error);
			})
			.finally(() => {
				this.loading = false;
			});
		});
	}
	
	get typeText() {
		const fieldType = CustomData.FIELD_TYPES.find(type => type.value === this.type);

		return fieldType ? fieldType.text : '';
	}

	get showItems() {
		return !this.disabled && ['dropdownList'].includes(this.type);
	}
	
	get labelText() {
		return this.label + (this.disabled ? ' (disabled)' : '');
	}
}

export class CustomDatas extends Collection {
	model() {
		return CustomData;
	}

	routes() {
		return {
			fetch: '/custom-datas?projectId={projectId}',
		};
	}
}

export class CustomDataItem extends Model {
	defaults() {
		return {
			label: '',
			order: null,
			parentId: null,
			value: '',
			disabled: false,
		};
	}

	mutations() {
		return {
			parentId: id => Number(id) || null,
			label: String,
			value: String,
			disabled: Boolean,
		};
	}

	validation() {
		return {
			parentId: integer.and(required),
			label: string.and(required).and(length(1, 100)),
		};
	}

	routes() {
		return {
			create: 'custom-data-items',
			patch: 'custom-data-items/{value}?parentId={parentId}',
			delete: 'custom-data-items/{value}?parentId={parentId}',
		};
	}

	options() {
		return {
			identifier: 'value',
			patch: true,
		};
	}

	isNew() {
		return this.value === '';
	}

	get labelText() {
		return this.label + (this.disabled ? ' (disabled)' : '');
	}
}

export class CustomDataItems extends Collection {
	model() {
		return CustomDataItem;
	}

	routes() {
		return {
			fetch: 'custom-data-items?parentId={parentId}',
		};
	}
}
